import styled from "styled-components"
import styledMap from "styled-map"

import { colors } from "~/styles"

export const LinkButton = styled.a`
  display: block;
  text-decoration: none;

  width: ${styledMap("size", {
    full: "100%",
    small: "auto",
    default: "auto",
  })};

  padding: ${styledMap("size", {
    small: "0rem 4rem",
    default: "1.5rem 2rem",
  })};

  height: ${styledMap("size", {
    small: "4rem",
    default: "1.5rem 2rem",
  })};

  color: ${styledMap("color", {
    secondary: colors.secondary,
    default: colors.primary,
  })};

  text-align: center;
  font-weight: bold;

  border: 2px solid;
  border-color: ${styledMap("color", {
    secondary: colors.secondary,
    default: colors.primary,
  })};

  border-radius: 3rem;
  background-color: transparent;
  outline: none;
  transition: 0.2s;

  &:hover,
  &:focus {
    cursor: pointer;
    color: ${styledMap("color", {
      secondary: colors.secondary,
      default: colors.lighter,
    })};
    border-color: ${colors.primary};
    background-color: ${colors.primary};
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  }
`
